import TransferTokensModal from './TransferTokensModal';

export default TransferTokensModal;



// WEBPACK FOOTER //
// ./src/components/TransferTokensModal/index.js